import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import Web3 from 'web3';
import cx from 'classnames';

import WithDrawHistory from './WithDrawHistory';
import CustomModal from '../../Components/Modal/CustomModal';
import CustomInput from '../../Components/Input/CustomInput';
import ActionModal from '../../Components/Modal/ActionModal';
import AuthBtn from '../../Components/Button/AuthBtn';
import PopUpModal from '../../Components/walletaction/PopupModal';
import { toast } from 'react-toastify';
import OCO_logo from '../../Assets/images/logo.svg';
import Walletaction from '../../Components/walletaction/Walletaction';
import TopNavBar from '../../Components/TopBar/Navbar';

import {
  REACT_APP_BUY_ETH_TOPIC0,
  REACT_APP_BUY_USD_TOPIC0,
  REACT_APP_OZK_VESTING, REACT_APP_OZK_VESTING_TOKEN,
  REACT_APP_PRIVATE_SALE, REACT_APP_RPC_URL, REACT_APP_START_BLOCK, REACT_APP_VESTED_TOPIC0, REACT_APP_WITHDRAW_TOPIC0,
} from '../../Config/Config';

import {
  useAccount,
  useWriteContract,
  useWaitForTransactionReceipt,
} from 'wagmi';

import NotConnectedModal from '../../Components/Modal/NotConectedModal';
import { useDepositContext } from '../../context/depositContext';
import {getConnections} from "@wagmi/core";
import wagmiAdapterConfig from "../../Config/WagmiConfig";
import PrivateSaleABI from "../../ContractABI/OZKPrivateSale.json";
import VestingManagerABI from "../../ContractABI/VestingManager.json";
import VestingWalletCliffAbi from '../../ContractABI/VestingWalletCliff.json';
import axios from 'axios';
import BigNumber from 'bignumber.js';

const Dashboard = () => {
  const {
    isWhitelisted,
    isVestedWalletDeployed,
    vestedWalletAddress,
    isPrivateSaleEnded,
    loadVestedWallet,
    vestedWalletAmount,
    loadVestedWalletAmount,
    balanceOfVestedWallet,
  } = useDepositContext();
  const { address, isConnected } = useAccount();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const [WithdrawModal, setWithdrawModal] = useState(false);
  const [Amount, setAmount] = useState(2000);
  const [ConfirmModal, setConfirmModal] = useState(false);

  const [WalletActionModal, setWalletActionModal] = useState(false);
  const [Loader1, setLoader1] = useState(false);
  const [Loader2, setLoader2] = useState(false);
  const [Loader3, setLoader3] = useState(false);
  const [Hashlink, setHashlink] = useState('');

  const [popupmodal, setpopupmodal] = useState(false);
  const [poptext, setpoptext] = useState('');

  const [initialAmount, setInitialAmount] = useState('');
  const [totalPurchased, setTotalPurchased] = useState(0);

  const [uintPerDay, setUnitPerDay] = useState(0);
  const [balance, setBalance] = useState(0);
  const [withdrawTxs, setWithdrawTxs] = useState([]);
  const connections = getConnections(wagmiAdapterConfig);

  const { data: hash, error, isPending, writeContract } = useWriteContract();

  useEffect(() => {
    if (isConnected) {
      getTotalPurchasedTokens();
      if (isWhitelisted) {
        return;
      }
      setModalOpen(true);
      setModalContent(
        'You have to be whitelisted in order to access page content!',
      );
      return;
    }

    setModalOpen(true);
    setModalContent(
      'You have to be connected in order to access page content!',
    );
  }, [isConnected, isWhitelisted]);
  
  useEffect(() => {
    if (isConnected && isVestedWalletDeployed) {
      fetchWithdrawTransactions();
      loadVestedWalletAmount();
    }
  }, [isConnected, isVestedWalletDeployed]);

  const { isLoading: isConfirming, isSuccess: isConfirmed } =
    useWaitForTransactionReceipt({ hash });
  
  const getTotalPurchasedTokens = async () => {
    const walletProvider = await connections[0].connector.getProvider();
    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }
    if (!address) {
      toast.warn('Wallet address not found');
      return;
    }
    const web3 = new Web3(walletProvider);
    const PrivateSaleContract = new web3.eth.Contract(PrivateSaleABI, REACT_APP_PRIVATE_SALE);
    try {
      const totalPurchased = await PrivateSaleContract.methods.getVestedListItem(address).call();
      if (totalPurchased[0]) {
        setTotalPurchased(Number(totalPurchased[1] / BigInt(10 ** 15))/1000);
        // correct formula is: totalPurchased - VestingWallet.vestedAmount(ozkTokenAddress, timestamp)
        setBalance(Number(totalPurchased[1] / BigInt(10 ** 15))/1000); // this needs to be updated with formula
        setInitialAmount(Number(totalPurchased[1] / BigInt(10 ** 15)) * 0.7 / 1000)
        setUnitPerDay(Number(totalPurchased[1] / BigInt(10 ** 15)) * 0.3 / (1000 * 365))
      }
    } catch (e) {
      console.log(e);
    }
  }
  
  const claimVestedWallet = async () => {
    const walletProvider = await connections[0].connector.getProvider();
    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }
    if (!address) {
      toast.warn('Wallet address not found');
      return;
    }
    const web3 = new Web3(walletProvider);
    const VestingManagerContract = new web3.eth.Contract(VestingManagerABI, REACT_APP_OZK_VESTING);
    try {
      setWalletActionModal(true);
      setLoader1(false);
      setLoader2(true);
      setLoader3(true);
      const vestedWallet = await VestingManagerContract.methods.claimVestedWallet().send({ from: address });
      
      if (vestedWallet.transactionHash) {
        setLoader2(false);
        setLoader3(false);
        setWalletActionModal(false);
        setHashlink(vestedWallet.transactionHash);
        toast.success('Vesting Wallet Deployed Successfully');
        setpoptext('Vesting Wallet Deployed Successfully');
        loadVestedWallet();
        loadVestedWalletAmount();
        setpopupmodal(true);
      }
    } catch (e) {
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
      
      console.log('Error deploy vested wallet==>', e);
      toast('Something went wrong. Please try again!');
    }
  };

  useEffect(() => {
    if (isConfirmed) {
      setLoader1(false);
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
    }
  }, [isConfirming, isConfirmed]);

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

  const ClosePopupModal = async () => {
    setpoptext('');
    setpopupmodal(false);
    loadVestedWallet();
    loadVestedWalletAmount();
    fetchWithdrawTransactions();
  };

  const CheckinScan = () => {
    toast.success('Withdrawal completed');
    setWalletActionModal(false);
  };

  const withdrawToken = async () => {
    if (vestedWalletAmount === 0) {
      toast.warn('Nothing to withdraw. Please try again later!');
      return;
    }
    const walletProvider = await connections[0].connector.getProvider();
    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }
    if (!address) {
      toast.warn('Wallet address not found');
      return;
    }
    const web3 = new Web3(walletProvider);
    const VestingWalletContract = new web3.eth.Contract(VestingWalletCliffAbi, vestedWalletAddress);
    
    try {
      setWalletActionModal(true);
      setLoader1(false);
      setLoader2(true);
      setLoader3(true);
      const claim = await VestingWalletContract.methods.release(REACT_APP_OZK_VESTING_TOKEN).send({ from: address });
      
      if (claim.transactionHash) {
        setLoader2(false);
        setLoader3(false);
        setWalletActionModal(false);
        setHashlink(claim.transactionHash);
        toast.success('Withdraw Successfully');
        setpoptext('OZK Claimed Successfully');
        setpopupmodal(true);
      }
    } catch (e) {
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
      
      console.log('Error Withdraw==>', e);
      toast('Something went wrong. Please try again!');
    }
  };
  
  const fetchWithdrawTransactions = async () => {
    const web3 = new Web3(REACT_APP_RPC_URL);
    try {
      if (web3 !== null && isVestedWalletDeployed) {
        const result = await axios.post(
          REACT_APP_RPC_URL,
          {
            jsonrpc: '2.0',
            id: 1,
            method: 'eth_getLogs',
            params: [
              {
                address: vestedWalletAddress,
                topics: [REACT_APP_WITHDRAW_TOPIC0],
                fromBlock: web3.utils.numberToHex(REACT_APP_START_BLOCK),
                toBlock: 'latest',
              },
            ],
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        
        
        const resultArray = result.data.result;
        
        const reversedList = resultArray.map((e, i, a) => a[a.length - 1 - i]);
        
        const transactionHistory = [];
        
        await Promise.all(
          reversedList.map(async (event) => {
            const data1 = web3.eth.abi.decodeLog(
              [
                {
                  indexed: true,
                  internalType: 'address',
                  name: 'token',
                  type: 'address',
                },
                {
                  indexed: false,
                  internalType: 'uint256',
                  name: 'amount',
                  type: 'uint256',
                },
              ],
              event.data, // Contains non-indexed parameters
              event.topics.slice(1), // Exclude topic0 (event signature hash)
            );
            
            const transactionHash = event.transactionHash;

            const _amount = BigNumber(data1.amount).div(10 ** 18).toNumber();
            const block = await web3.eth.getBlock(
              web3.utils.hexToNumber(event.blockNumber),
            );
            const timestamp = Number(block.timestamp) * 1000;
            
            const time = String(new Date(timestamp)).slice(4, 21);
            const date = Number(timestamp);
            const transaction = {
              transactionHash,
              amount: _amount,
              time,
              date,
            };
            transactionHistory.push(transaction);
          }),
        );
        
        setWithdrawTxs(transactionHistory);
      }
    } catch (err) {
      console.log('Error withdraw txs=>', err);
    }
  };

  const vestingAvailableBalance = useMemo(() => BigNumber(balanceOfVestedWallet).minus(vestedWalletAmount).toString(), [balanceOfVestedWallet, vestedWalletAmount]);

  return (
    <>
      {' '}
      <Grid
        container
        sm={12}
        xs={12}
        display={'flex'}
        flexDirection={'row'}
        alignItems={'flex-start'}
        justifyContent={'center'}
        className={'dashboardBG'}
      >
        <Grid container position={'fixed'} zIndex={100}>
          <TopNavBar />
        </Grid>
        <Grid
          container
          sm={11}
          xs={12}
          display={'flex'}
          justifyContent={{ sm: 'space-between', xs: 'center' }}
          className={cx([
            'main_position',
            (!isWhitelisted || !isConnected) && 'blurredBG',
          ])}
        >
          {/* Initial 3 Cards */}
          <Grid
            container
            lg={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'stretch'}
            justifyContent={'space-evenly'}
          >
            <Grid
              item
              lg={3.8}
              sm={3.8}
              xs={11}
              className="dash_common_layer p-2 mt-2"
            >
              <Grid
                lg={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'space-between'}
                className="p-3 h-100"
              >
                <h4>Purchased OZK</h4>

                <h3
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {formatter.format(totalPurchased)}{' '}
                  <img
                    src={OCO_logo}
                    width={'30px'}
                    height={'30px'}
                    alt="OCO_logo"
                    className="mx-2"
                  />{' '}
                </h3>
              </Grid>
            </Grid>
            <Grid
              item
              lg={3.8}
              sm={3.8}
              xs={11}
              className="dash_common_layer p-2 mt-2"
            >
              <Grid
                lg={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'space-between'}
                className="p-3 h-100"
              >
                <h4 className='text-center'>OZK Subject to Vesting</h4>
                <h3
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {isVestedWalletDeployed ? formatter.format(vestingAvailableBalance) : formatter.format(totalPurchased)}{' '}
                  <img
                    src={OCO_logo}
                    width={'30px'}
                    height={'30px'}
                    alt="OCO_logo"
                    className="mx-2"
                  />{' '}
                </h3>
              </Grid>
            </Grid>
            <Grid
              item
              lg={3.8}
              sm={3.8}
              xs={11}
              className="dash_common_layer p-2 mt-2"
            >
              <Grid
                lg={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                className="p-3 h-100"
              >
                <h4 className='text-center'>Vested OZK Available to Claim / Withdraw</h4>
                <div className="d-flex alig-Items-center ">
                  {isConnected ? (
                    <>
                      <h3 className="mt-2 mx-2 text-center">{formatter.format(vestedWalletAmount)}
                        <img
                          src={OCO_logo}
                          width={'30px'}
                          height={'30px'}
                          alt="OCO_logo"
                          className="mx-2"
                        /></h3>
                    </>
                  ) : (
                    ''
                  )}
                </div>
                {isConnected ? (
                  <button
                    className="btn btn-0  w-75 p-2 mt-3"
                    style={{
                      backgroundColor: '#000',
                      color: '#FFED8C',
                      border: '1px solid #FFED8C',
                    }}
                    onClick={() => {
                      isVestedWalletDeployed ? withdrawToken() : claimVestedWallet();
                    }}
                    disabled={totalPurchased === 0 || !isPrivateSaleEnded || (vestedWalletAmount === 0 && isVestedWalletDeployed)}
                  >
                    {isVestedWalletDeployed ? 'CLAIM' : 'DEPLOY CONTRACT'}
                  </button>
                ) : (
                  <h4 className="mt-2 mx-2" style={{ color: '#FFCB9E' }}>
                    Connect Wallet
                  </h4>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            lg={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'stretch'}
            justifyContent={'space-evenly'}
            className=" py-3"
          >
            {/* Details Card */}

            <Grid
              container
              lg={5.8}
              sm={5.8}
              xs={11}
              className="p-3 dash_details_layer mt-2"
            >
              <Grid
                container
                lg={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'flex-start'}
                justifyContent={'flex-start'}
                className="p-2"
              >
                <h5 className="w-100 text-left py-1"> Details</h5>

                <Grid
                  container
                  lg={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="dash_details_inner px-3 py-2 mt-2"
                >
                  <p className="py-3">Purchased OZK</p>
                  <Grid
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                  >
                    <img
                      src={OCO_logo}
                      alt="coin"
                      style={{ height: '25px', width: '25px' }}
                    />
                    <p className="mx-2">{formatter.format(totalPurchased)}</p>
                  </Grid>
                </Grid>

                <Grid
                  container
                  lg={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="dash_details_inner px-3 py-2 mt-2"
                >
                  <p className="py-3" style={{maxWidth: '60%'}}>OZK to Vest and Claimable Upon TGE</p>
                  <Grid
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                  >
                    <p className="d-flex align-items-center">
                      <img
                        src={OCO_logo}
                        alt="coin"
                        style={{ height: '25px', width: '25px' }}
                      />
                      <p className="mx-2">{formatter.format(initialAmount)}</p>
                    </p>
                  </Grid>
                </Grid>

                <Grid
                  container
                  lg={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="dash_details_inner px-3 py-2 mt-2"
                >
                  <p className="py-3" style={{width: '30%'}}>OZK Vesting Schedule</p>
                  <p style={{width: '50%'}} className='text-right'>30% of Purchased OZK over 12 months from TGE</p>
                </Grid>
                <Grid
                  container
                  lg={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="dash_details_inner px-3 py-2 mt-2"
                >
                  <p className="py-3">Vesting Frequency</p>
                  <p>Linear</p>
                </Grid>
                <Grid
                  container
                  lg={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                  className="dash_details_inner px-3 py-2 mt-2"
                >
                  <p className="py-3">OZK Vesting per day</p>
                    <p className="d-flex align-items-center">
                      <img
                        src={OCO_logo}
                        alt="coin"
                        style={{ height: '25px', width: '25px' }}
                      />
                      <p className="mx-2">{formatter.format(uintPerDay)}</p>
                    </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              container
              lg={5.8}
              sm={5.8}
              xs={11}
              className="p-3 dash_withdraw_history mt-2"
            >
              <Grid
                container
                lg={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'flex-start'}
                justifyContent={'flex-start'}
                className="px-2"
              >
                <WithDrawHistory
                  WithdrawData={withdrawTxs}
                  reloadtransaction={fetchWithdrawTransactions}
                />
              </Grid>
            </Grid>
          </Grid>
          
          <CustomModal
            open={WithdrawModal}
            setOpen={setWithdrawModal}
            modalTitle={<h5>Withdraw</h5>}
            modalContent={
              <Grid
                container
                lg={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'flex-start'}
              >
                <img
                  src={OCO_logo}
                  alt="OCO_logo"
                  style={{ height: '80px', width: '80px' }}
                />
                <h3 className="py-3">2,000</h3>
                <CustomInput
                  placeholder={'Enter Withdraw Amount'}
                  isBorder={true}
                  borderColor={'#fff'}
                  maxLength={15}
                  inputType={'number'}
                  icon={<p>Max</p>}
                  Value={Amount}
                  handleInput={(e) => setAmount(e)}
                />
                <button className="btn btn-0 border-0 WidthDrawbtn w-100 p-2 text-light mt-3">
                  WITHDRAW
                </button>
              </Grid>
            }
          />

          <ActionModal
            open={ConfirmModal}
            setOpen={setConfirmModal}
            modalTitle={<h5>Sure you want to Withdraw ?</h5>}
            modalContent={
              <Grid
                container
                lg={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <img
                  src={OCO_logo}
                  alt="OCO_logo"
                  style={{ height: '50px', width: '50px' }}
                />
                <h2 className="mx-2 mt-2">{Amount}</h2>
                <Grid
                  container
                  lg={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  className="mt-4"
                >
                  <Grid item lg={4}>
                    <AuthBtn
                      btnColor={'transparent'}
                      btnTextColor="#FFF"
                      text={'CANCEL'}
                      borderColor={'#ffff'}
                      width="90%"
                      onClick={() => setConfirmModal(false)}
                    />
                  </Grid>
                  <div className="p-2" />
                  <Grid item lg={4}>
                    <AuthBtn
                      btnTextColor="#FFF"
                      text={'CONFIRM'}
                      borderColor={'#ffff'}
                      width="90%"
                    />
                  </Grid>
                </Grid>
              </Grid>
            }
          />

          <Walletaction
            WalletActionModal={WalletActionModal}
            Loader1={Loader1}
            Loader2={Loader2}
            Loader3={Loader3}
            handleClose={CheckinScan}
            isCompleted={Hashlink}
          />

          <PopUpModal
            popupmodal={popupmodal}
            poptext={poptext}
            handleClose={ClosePopupModal}
          />
        </Grid>
      </Grid>
      {(!isConnected || !isWhitelisted) && (
        <NotConnectedModal
          open={modalOpen}
          setOpen={setModalOpen}
          modalContent={modalContent}
          modalTitle=""
          width={{lg: '30%', md: '30%', sm: '90%', xs: '90%'}}
        />
      )}
    </>
  );
};

export default Dashboard;
